import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../api/hooks/useColors";

export const SeeMoreContent = ({
  content,
  initialCharCount = 190,
  lineHeight = 1.3,
  marginTop = "2%",
  fontSize = null,
}) => {
  const [expanded, setExpanded] = useState(false);
  const colors = useColors();
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Avoid visible line-height jump when toggling between expanded and collapsed
  const LINE_HEIGHT_DIFF = 0.3;

  const displayedContent = expanded
    ? content
    : content?.slice(0, initialCharCount);

  return (
    <Box mt={marginTop}>
      <Typography
        variant="body2"
        sx={{
          lineHeight: lineHeight,
          ...(fontSize && { fontSize: fontSize }),
        }}
      >
        {displayedContent}
        {!expanded && content?.length > initialCharCount && "... "}
        {content?.length > initialCharCount && (
          <Button
            onClick={toggleExpanded}
            size="small"
            sx={{
              textTransform: "none",
              color: colors.text_secondary,
            }}
          >
            <Typography
              variant="overline"
              sx={{ lineHeight: lineHeight - LINE_HEIGHT_DIFF }}
            >
              {expanded ? "See Less" : "See More"}
            </Typography>
          </Button>
        )}
      </Typography>
    </Box>
  );
};
